import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import Lotnisko from "../Lotnisko";

class OpisWyjazduLoty extends PureComponent<any> {
  render() {
    const { routes } = this.props;
    if (!routes || routes.length === 0) return null;
    return (
      <section className="OpisWyjazduLoty">
        {routes.length > 1 ? "Loty" : "Lot"}:
        <ul className="OpisWyjazduLoty_list">
          {routes
            .filter((route: any) => route.isCanceled !== true)
            .map((route: any) => (
              <li key={route.dep + "-" + route.arr}>
                <Lotnisko id={route.dep} /> - <Lotnisko id={route.arr} />
              </li>
            ))}
        </ul>
      </section>
    );
  }
}

export default OpisWyjazduLoty;
